module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud-fog-d9e5acecc79e75ce137de5d445261996.svg";